import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchCompany, acceptCompanyTOS } from "../actions/index";

class CompanyStatusCheck extends Component {
  static propTypes = {
    fetchCompany: PropTypes.func.isRequired,
    company: PropTypes.object,
    history: PropTypes.object.isRequired,
    acceptCompanyTOS: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.fetchCompany().then(response => {
      if (response.payload.data.data.latest_tos_accepted != true) {
        this.props.history.push(`/terms`);
      } else if (response.payload.data.data.status != "enabled") {
        this.props.history.push(`/status`);
      }
    });
  }

  agree() {
    this.props.acceptCompanyTOS().then(response => {
      if (response.payload.status == "200") {
        this.closeModal();
      }
    });
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return { company: state.company.company };
}

export default connect(
  mapStateToProps,
  { fetchCompany, acceptCompanyTOS }
)(CompanyStatusCheck);
